import { SalesCapacityComponent } from './sales-capacity.component';
import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { DeactivateGuard } from '../../shared/guards/candeactivate';


const routes: Routes = [
    {
        path: '',
        component: SalesCapacityComponent,
        canDeactivate:[DeactivateGuard]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class SalesCapacityRoutingModule { }
